import VuexStore from "@/store/vuex/VuexStore";

export default function(options) {
    if (VuexStore.state.account.showAVE) return options.fn(this);
    return options.inverse(this);
}